<template>
    <!-- accessories -->
    <section class="section-pad" id="accessories">
        <el-row type="flex" justify="center">
            <el-col :lg="22" :xs="22" :md="22" :sm="22" :xl="22">
                <el-row :gutter="30">
                    <el-col :lg="8" :xs="24" :sm="12" :md="12" :xl="8">
                        <router-link
                                :to="{ name: 'products', params: { category: 'apple-watch-accessories' } }"
                        >
                            <div class="each-accessorie">
                                <div class="image">
                                    <img
                                            src="/img/accessories/accessories-2.png"
                                            alt="Apple Watch Accessories"
                                            class="img-fluid"
                                    />
                                </div>
                                <div class="accessorie-details">
                                    <h3 class="orange-color">Apple Watch Accessories</h3>
                                </div>
                            </div>
                        </router-link>
                    </el-col>
                    <el-col :lg="8" :xs="24" :sm="12" :md="12" :xl="8">
                        <router-link
                                :to="{ name: 'products', params: { category: 'ipad-cases' } }"
                        >
                            <div class="each-accessorie">
                                <div class="image">
                                    <img
                                            src="/img/accessories/accessories-7.png"
                                            alt="Ipad accessories"
                                            class="img-fluid"
                                    />
                                </div>
                                <div class="accessorie-details">
                                    <h3 class="orange-color">IPad Accessories</h3>
                                </div>
                            </div>
                        </router-link>
                    </el-col>
                    <el-col :lg="8" :xs="24" :sm="24" :md="12" :xl="8">
                        <router-link
                                :to="{ name: 'products',  params: { category: 'mac-accessories' } }"
                        >
                            <div class="each-accessorie">
                                <div class="image">
                                    <img
                                            src="/img/accessories/accessories-4.jpg"
                                            alt="mac accessories"
                                            class="img-fluid"
                                    />
                                </div>
                                <div class="accessorie-details">
                                    <h3 class="orange-color">Mac Accessories</h3>
                                </div>
                            </div>
                        </router-link>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </section>
</template>

<script>
    export default {
        name: "Accesssories",
        data() {
            return {};
        }
    };
</script>

<style scoped lang="scss">
    #accessories {
        .each-accessorie {
            .image {
                img {
                    border-radius: 0.313em;
                }
            }

            .accessorie-details {
                margin-top: 0.5em;

                h3 {
                    margin-bottom: 0.313em;
                    font-size: 1.4em;
                    @media (max-width: 768px) {
                        text-align: center;
                        font-size: 1.2em;
                    }
                }

                p {
                    margin-top: 0;
                    font-size: 1em;
                    text-transform: uppercase;
                }
            }
        }
    }
</style>
